const validateField = (conditional, error) =>
    conditional ? [error] : undefined;

export const required = (value) =>
    value ? undefined : ['This is a required field'];

export const phoneNumber = (value) =>
    validateField(
        !/^(?!555[01])([2-9][0-9]{9})$/i.test(value),
        'Invalid phone number, must be 10 digits',
    );

export const phoneVerificationCode = (value) =>
    validateField(
        value && !/^([0-9]{4})$/i.test(value),
        'Invalid code, must be 4 digits',
    );

export const hasLower = (input) => /[a-z]/.test(input);

export const hasCapital = (input) => /[A-Z]/.test(input);

export const hasNumber = (input) => /\d/.test(input);

export const lowerCaseRequired = (
    value,
    error = 'A lower case character is required',
) => validateField(!hasLower(value), error);

export const upperCaseRequired = (
    value,
    error = 'An upper case character is required',
) => validateField(!hasCapital(value), error);

export const numberRequired = (value, error = 'A number is required') =>
    validateField(!hasNumber(value), error);

export const hasMinMaxChars = (value, min = 8, max = 100, error = null) => {
    const errorMessage =
        error || `Length should be between ${min} and ${max} characters`;
    const regex = new RegExp(`.{${min},${max}}`);
    return validateField(!regex.test(value), errorMessage);
};

// Intl.Segmenter allows us to correctly capture multi-codepoint chars like emojis and accented letters
const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
export const latin1Only = (value) => {
    if (!value) return undefined;

    // Check if any character/character group is outside Latin-1 range (0x00-0xFF)
    const chars = Array.from(segmenter.segment(value), (s) => s.segment);
    const charIdx = chars.findIndex((char) =>
        Array.from(char).some((c) => c.charCodeAt(0) > 0xff),
    );

    return validateField(
        charIdx >= 0,
        `This character is invalid: ${chars[charIdx]}`,
    );
};

// Apply multiple validators, returning an error from the first failed validator
export const combined = (validators) => {
    const valueThroughValidators = (value) => {
        for (let i = 0; i < validators.length; i += 1) {
            const validator = validators[i];
            const error = validator(value);
            if (typeof error !== 'undefined') {
                return error;
            }
        }
        return undefined;
    };
    return valueThroughValidators;
};
